import {BasicService} from './basic.service';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_PLANT_URL } from '../../connection.data';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable()
export class PlantService extends BasicService {

    private currentPlant:any = null;
    plantLoaded$: BehaviorSubject<boolean> = new BehaviorSubject(false);

    constructor(http: HttpClient){
        super(http);
        this.baseUrl = API_PLANT_URL;
        const plantStr = localStorage.getItem(environment.plant);
        //console.log("plant str from storage: "+plantStr);
        if(plantStr){
            this.currentPlant = JSON.parse(plantStr);
            //console.dir(this.currentPlant);
            this.plantLoaded$.next(true);
        }
    }

    setCurrentPlant(plant){
        this.currentPlant = plant;
        localStorage.setItem(environment.plant, JSON.stringify(this.currentPlant));
        this.plantLoaded$.next(true);
    }

    getCurrentPlant(){
        return this.currentPlant;
    }
}
